import { FormFieldType, TFormField } from '@models/forms/formFields.type';
import { TPolicyMonolineInsuranceLine } from '@services/policy/useGetAvailablePolicyMonolineInsuranceLines';
import { fakeLocalMidnightFromTZMidnight } from '@utils/date';
import { isValid } from 'date-fns';

export function getFormFields({
  newPolicyLOI,
  policyEffectiveDate,
  policyExpirationDate,
}: {
  newPolicyLOI: {
    items: TPolicyMonolineInsuranceLine[];
  };
  policyEffectiveDate: {
    minDate?: Date;
    maxDate?: Date;
    overlapError?: boolean;
  };
  policyExpirationDate: {
    minDate?: Date;
    maxDate?: Date;
    overlapError?: boolean;
  };
}): {
  [fieldName: string]: TFormField;
} {
  return {
    newPolicyLOI: {
      gridWidth: { xs: 12, sm: 12 },
      name: 'newPolicyLOI',
      label: 'New Policy LOI',
      fieldType: FormFieldType.RadioGroupField,
      required: true,
      sx: { marginLeft: '-8px !important', marginBottom: '-8px !important' },
      fieldConfig: {
        radioField: {
          layout: 'vertical',
          options: newPolicyLOI.items.map((item) => ({
            value: item.id,
            label: item.name,
            disabled: !item.isEnabled,
            tooltip: !item.isEnabled ? item.message : undefined,
          })),
        },
      },
    },
    policyEffectiveDate: {
      gridWidth: { xs: 12, sm: 6 },
      name: 'policyEffectiveDate',
      label: 'New Policy Effective Date',
      fieldType: FormFieldType.DatePickerField,
      required: true,
      error: policyEffectiveDate.overlapError,
      helperText: policyEffectiveDate.overlapError ? 'Selected dates overlap with existing linked policy' : undefined,
      fieldConfig: {
        dateField: {
          minDate:
            policyEffectiveDate.minDate && isValid(policyEffectiveDate.minDate)
              ? fakeLocalMidnightFromTZMidnight(policyEffectiveDate.minDate)
              : undefined,
          maxDate:
            policyEffectiveDate.maxDate && isValid(policyEffectiveDate.maxDate)
              ? fakeLocalMidnightFromTZMidnight(policyEffectiveDate.maxDate)
              : undefined,
        },
      },
    },
    policyExpirationDate: {
      gridWidth: { xs: 12, sm: 6 },
      name: 'policyExpirationDate',
      label: 'New Policy Expiration Date',
      fieldType: FormFieldType.DatePickerField,
      required: true,
      error: false,
      helperText: undefined,
      fieldConfig: {
        dateField: {
          minDate:
            policyExpirationDate.minDate && isValid(policyExpirationDate.minDate)
              ? fakeLocalMidnightFromTZMidnight(policyExpirationDate.minDate)
              : undefined,
          maxDate:
            policyExpirationDate.maxDate && isValid(policyExpirationDate.maxDate)
              ? fakeLocalMidnightFromTZMidnight(policyExpirationDate.maxDate)
              : undefined,
        },
      },
    },
  };
}
